import {
    IonText,
    IonGrid,
    IonRow,
    IonCol,
    IonImg,
  } from "@ionic/react";
  import { useState } from "react";
  
  import "./AccordianCoreContentImgExp.css";
  
  import "../../Fonts.css";
  
  interface AccordianCoreContentImgExpProps {
    text: string;
    imageUrl: string;
  }
  
  const AccordianCoreContentImgExp: React.FC<AccordianCoreContentImgExpProps> = ({text, imageUrl}) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggleAccordion = () => {
      setIsOpen(!isOpen);
    };
  
    return (
      <div className="acceMainContainer">
        <IonGrid>
          <IonRow>
            <IonCol size="12">
              <IonImg src={imageUrl} />
            </IonCol>
            <IonCol className="accieTitleCol">
              <IonText className="acceTitleText" dangerouslySetInnerHTML={{ __html: text }}></IonText>
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
    );
  };
  
  export default AccordianCoreContentImgExp;
  